import type {
  Alert,
  Phone,
} from "@tandemdiabetes/sugarmate-api-react-client"
import { useTestNotifications } from "@tandemdiabetes/sugarmate-api-react-client"
import {
  PopoverMenuItemIcon,
  PhoneIcon,
  useToasterContext,
} from "@tandemdiabetes/sugarmate-react-components"
import { useMemo } from "react"

import type { TestFunctionality } from "../Contacts/TestFunctionality"
import { usePolyglot } from "src/contexts"
import {
  GenericErrorToast,
  TestSMSSuccessToast,
} from "src/toasts"

const polyglotPrefix = "pages.alerts.sms."

export function useTestSMSAlertFunctionality(
  urgentLowSMS: Alert | undefined,
): TestFunctionality | undefined {
  const polyglot = usePolyglot()
  const { showToast } = useToasterContext()
  const testNotification = useTestNotifications()

  return useMemo(
    () => !urgentLowSMS || !testNotification
      ? undefined
      : ({
        onClick: (phone: Phone) => {
          void (async () => {
            try {
              await testNotification(
                urgentLowSMS.id,
                phone.id,
              )
              showToast(
                "test-sms-success-toast",
                TestSMSSuccessToast,
              )
            } catch {
              showToast(
                "test-sms-error-toast",
                GenericErrorToast,
              )
            }
          })()
        },
        children: (
          <>
            <PopoverMenuItemIcon>
              <PhoneIcon />
            </PopoverMenuItemIcon>
            {polyglot.t(`${polyglotPrefix}test_cta`)}
          </>
        ),
      }),
    [
      polyglot,
      showToast,
      urgentLowSMS,
      testNotification,
    ],
  )
}
